import {create} from 'zustand';

type EmberModalsStackState = {
  modalsStack: string[];
};

const initialState: EmberModalsStackState = {
  modalsStack: [],
};

const emberModalsStackStore = create<EmberModalsStackState>(() => initialState);

const setEmberModalsStack = (modalNameOrFalse: string | false) =>
  emberModalsStackStore.setState((state) => ({
    modalsStack: modalNameOrFalse
      ? [...state.modalsStack, modalNameOrFalse]
      : state.modalsStack.slice(0, -1),
  }));

export const emberModalsStackActions = {
  setEmberModalsStack,
};

export default emberModalsStackStore;
